"use client";

import { Shield, User, ThumbsUp } from "lucide-react";
import { motion } from "motion/react";

const trustItems = [
  {
    icon: User,
    text: "Verified Tenants Only",
    description: "Every review is from a confirmed tenant"
  },
  {
    icon: Shield,
    text: "Anonymous & Secure",
    description: "Your privacy is our priority"
  },
  {
    icon: ThumbsUp,
    text: "Landlord Ratings",
    description: "Fair and transparent scoring"
  }
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut" as const
    }
  }
};

const TrustStrip = () => {
  return (
    <div className="bg-white py-8 md:py-12 border-t border-b border-gray-100">
      <div className="container mx-auto px-4">
        <motion.div 
          className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {trustItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <motion.div
                key={index}
                className="flex flex-col items-center text-center group"
                variants={itemVariants}
              >
                <div className="mb-3 p-3 rounded-full bg-blue-50 group-hover:bg-blue-100 transition-colors duration-300">
                  <IconComponent className="h-6 w-6 text-blue-600" />
                </div>
                <span className="text-gray-900 font-semibold mb-1">{item.text}</span>
                <span className="text-sm text-gray-500">{item.description}</span>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </div>
  );
};

export default TrustStrip;
